<template>
    <span>
        <button
            v-if="type === 'archive'"
            class="btn btn-sm btn-danger"
            type="button"
            @click="openModal()"
        >
            <i class="fa fa-archive"></i>
            <span class="sr-only">Archive</span>
        </button>
        <button
            v-else-if="type === 'lookup'"
            class="btn btn-sm btn-info"
            type="button"
            @click="openModal()"
        >
            <i class="fa fa-search-plus"></i>
            <span class="sr-only">Carrier Lookup</span>
        </button>
        <button
            v-else-if="type === 'lookupRest'"
            class="btn btn-sm btn-danger"
            type="button"
            @click="openModal()"
        >
            <i class="fa fa-search-plus"></i>
            <span class="sr-only">Carrier Lookup</span>
        </button>
        <button
            v-else-if="type === 'delete'"
            class="btn btn-sm btn-danger"
            type="button"
            @click="openModal()"
        >
            <i class="fa fa-trash"></i>
            <span class="sr-only">Delete</span>
        </button>
    </span>
</template>

<script>
export default {
    data() {
        return {
            modal: {
                'class': 'modal-lists',
                'header': '',
                'body': '',
                'isBodyHtml': true,
                'id': '',
                'active': '',
            }
        }
    },
    props: {
        'id': Number,
        'type': String,
        'route': Object,
    },
    methods: {
        click: function () {
            this.$emit('modalEmitData', this.modal);
            return this.$emit('click');
        },
        emitModalData: function () {
            return this.$emit('modalEmitData', this.modal);
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        openModal: function () {
            this.click();
            this.modal = this[this.type]();
            this.emitModalData();
        },
        archive() {
            return {
                header: 'Archive Contact List #' + this.id,
                bodyHeader: 'Confirm Contact List archiving please.',
                body: 'Contacts in that List will be deactivated.',
                btnColor: 'btn-danger',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: 'Archive',
                denyText: '',
                method: 'PUT',
            }
        },
        lookup() {
            return {
                header: 'Lookup Contact List #' + this.id,
                bodyHeader: 'Confirm carriers lookup for Contact List please.',
                body: '',
                btnColor: 'btn-info',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: 'Lookup',
                denyText: '',
                method: 'POST',
            }
        },
        lookupRest() {
            return {
                header: 'Reset Lookup Contact List #' + this.id,
                bodyHeader: 'Confirm carrier lookup data reset for Contact List please.',
                body: '',
                btnColor: 'btn-danger',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: 'Reset',
                denyText: 'Cancel',
                method: 'POST',
            }
        },
        delete() {
            return {
                header: 'Delete Category #' + this.id,
                bodyHeader: 'Confirm the Category deletion please.',
                body: '',
                btnColor: 'btn-danger',
                action: this.getRoute(this.id, this.type),
                id: this.id,
                approveText: 'Delete',
                denyText: 'Close',
                method: 'DELETE',
            }
        },
    },
}
</script>
